import type { CustomerType } from '@/store/types/user'

export const customerTypeHasSubscriptionDiscount = (
  customerType: CustomerType,
) => customerType === 'Member' || customerType === 'Associate'
